import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | Almeida's Home Services" description="The page you're looking for doesn't exist. Return home or browse our services." path="/404" noindex />
      {/* Hint prerender/crawlers this is a 404 */}
      <Helmet><meta name="prerender-status-code" content="404" /></Helmet>
      <section className="min-h-[70vh] flex items-center bg-cloud pt-24" data-testid="notfound-page">
        <div className="max-w-[700px] mx-auto px-5 md:px-12 text-center">
          <div className="font-display font-bold text-royal text-7xl md:text-9xl">404</div>
          <h1 className="mt-4 font-display font-bold uppercase text-navy text-3xl md:text-4xl tracking-tight">Page not found</h1>
          <p className="mt-4 font-body text-navy/60 text-lg">
            The page you're looking for doesn't exist or may have moved.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" className="rounded-full bg-gold hover:bg-gold-hover text-navy-dark font-bold uppercase tracking-wide text-sm px-7 py-3.5 transition-colors">Home</Link>
            <Link to="/service-areas" className="rounded-full bg-white border border-navy/15 text-navy font-semibold text-sm px-7 py-3.5 hover:border-gold transition-colors">Service Areas</Link>
            <Link to="/contact" className="rounded-full bg-white border border-navy/15 text-navy font-semibold text-sm px-7 py-3.5 hover:border-gold transition-colors">Contact</Link>
          </div>
        </div>
      </section>
    </>
  );
}
